// token-storage.ts

let accessToken = ''; // Store the token in a private variable

export function setAccessToken(token: string) {
  // Update the token
  accessToken = token;
}

export function getAccessToken(): string {
  // Retrieve the token
  return accessToken;
}

export function clearTokens() {
  // Clear the token upon logout
  accessToken = '';
}